export const TIMEZONE_KEY = '@IDV:transportation-timezone'
